import React from 'react';
import Icon from '../../components/AppIcon';
import Button from '../ui/Button';
import CalendarIntegration from './CalendarIntegration';

/**
 * Modal for displaying detailed interview information with action buttons
 */
const InterviewDetailsModal = ({
  interview,
  onClose,
  onReschedule,
  onCancel,
  onComplete,
  onContactCandidate
}) => {
  if (!interview) return null;
  
  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-start mb-4">
            <h2 className="text-xl font-bold">Interview Details</h2>
            <button 
              onClick={onClose}
              className="p-1 hover:bg-gray-100 rounded-full"
            >
              <Icon name="X" size={20} />
            </button>
          </div>
          
          <div className="space-y-6">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center">
                <Icon name="User" size={24} className="text-primary-600" />
              </div>
              <div>
                <h3 className="font-medium text-lg">{interview.candidate_name}</h3>
                <p className="text-text-secondary">{interview.job_title}</p>
              </div>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="text-sm text-text-secondary">Date & Time</p>
                <p>{new Date(interview.scheduled_at).toLocaleString()}</p>
              </div>
              <div>
                <p className="text-sm text-text-secondary">Interview Type</p>
                <p className="capitalize">{interview.type}</p>
              </div>
              <div>
                <p className="text-sm text-text-secondary">Status</p>
                <p className="capitalize">{interview.status}</p>
              </div>
              <div>
                <p className="text-sm text-text-secondary">Duration</p>
                <p>{interview.duration || 60} minutes</p>
              </div>
            </div>
            
            {interview.notes && (
              <div>
                <p className="text-sm text-text-secondary mb-1">Notes</p>
                <p className="bg-background p-3 rounded-md">{interview.notes}</p>
              </div>
            )}
            
            <CalendarIntegration interview={interview} />
            
            <div className="flex justify-end space-x-3 pt-4">
              {interview.status === 'scheduled' && (
                <>
                  <Button variant="outline" onClick={onReschedule}>
                    Reschedule
                  </Button>
                  <Button variant="outline" onClick={onCancel}>
                    Cancel
                  </Button>
                  <Button variant="primary" onClick={onComplete}>
                    Complete Interview
                  </Button>
                </>
              )}
              {interview.status === 'completed' && (
                <Button variant="primary" onClick={onContactCandidate}>
                  Contact Candidate
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Export both default and named export to ensure it's properly recognized
export { InterviewDetailsModal };
export default InterviewDetailsModal;